import React from 'react';

import Slot from 'common/components/slot/Slot';
import GridStyleLayout from 'common/components/layout/GridStyleLayout';

const ManageScheduleDownloadLayout = (props) => {
  const { children } = props;

  const layoutAreas = [['toolbar'], ['grid']];

  return (
    <GridStyleLayout
      className='download-folder'
      areas={layoutAreas}
      rows='auto 1fr'
      columns='1fr'
      gap={8}
    >
      <Slot name='toolbar' layoutArea='toolbar'>
        {children}
      </Slot>
      <Slot name='grid' layoutArea='grid'>
        {children}
      </Slot>
    </GridStyleLayout>
  );
};

export default ManageScheduleDownloadLayout;
